/**
 * Default match between an SBOM value (a role) and a field of the Component form, by the
 * field's TITLE. Each role has a list of names, best first. A title that IS one of the names
 * beats a title that only contains one, and a shorter title beats a longer one ("Supplier"
 * before "Supplier contact"). One field is given to one role only, best score first.
 *
 * Only a suggestion: the settings form marks it "Suggested" and nothing is kept until Save.
 */
const NAMES = {
  version: ['software version', 'component version', 'version', 'version number', 'ver', 'revision'],
  purl: ['purl', 'package url', 'package uri', 'package id', 'package identifier'],
  ecosystem: ['ecosystem', 'package manager', 'package ecosystem', 'package type', 'language', 'platform'],
  type: ['component type', 'software type', 'soup type', 'category', 'kind'],
  supplier: ['supplier', 'vendor', 'manufacturer', 'publisher', 'provider', 'organization', 'organisation'],
  author: ['author', 'authors', 'developer', 'maintainer'],
  licence: ['licence', 'license', 'licences', 'licenses', 'licence type', 'license type'],
  hash: ['sha 256', 'sha256', 'hash', 'checksum', 'digest'],
  url: ['website', 'web site', 'homepage', 'download url', 'download', 'url', 'link'],
  support_level: ['level of support', 'support level', 'support status', 'maintenance status', 'support'],
  end_of_support: ['end of support', 'end of support date', 'eos', 'eos date', 'end of life', 'eol', 'eol date', 'support end date', 'sunset date'],
  sbom_url: ['sbom url', 'sbom link', 'sbom', 'open in sbom', 'sbom page'],
  soup_class: ['soup class', 'software safety class', 'safety class', 'iec 62304 class', '62304 class', 'soup classification', 'safety classification'],
};

const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
const words = (s) => (s ? s.split(' ') : []);

function score(role, title) {
  const t = norm(title);
  const tw = words(t);
  let best = 0;
  (NAMES[role] || []).forEach((name, i) => {
    const n = norm(name);
    let s = 0;
    if (t === n) s = 100 - i;
    else if (n.length >= 3 && ` ${t} `.includes(` ${n} `)) s = 60 - i - 2 * (tw.length - words(n).length);
    if (s > best) best = s;
  });
  return best;
}

/**
 * @param roles   role keys to fill
 * @param fields  the form's fields ({title})
 * @param taken   field titles already mapped to another role — never offered again
 * @returns {role: title} for the roles a field was found for
 */
export function suggestFieldMap(roles, fields, taken = []) {
  const used = new Set(taken.filter(Boolean));
  const pairs = [];
  roles.forEach((r) => (fields || []).forEach((f) => {
    const s = score(r, f.title);
    if (s > 0) pairs.push({ r, title: f.title, s });
  }));
  pairs.sort((a, b) => b.s - a.s);
  const out = {};
  pairs.forEach(({ r, title }) => {
    if (out[r] || used.has(title)) return;
    out[r] = title;
    used.add(title);
  });
  return out;
}
